// extracted by mini-css-extract-plugin
export default {"goldButton":"GoldButton_goldButton__hxlzn","goldButton__chosen":"GoldButton_goldButton__chosen__H9sos"};